package com.narbase.letsgo.web.views.operationSetting

import com.narbase.kunafa.core.components.*
import com.narbase.kunafa.core.components.layout.LinearLayout
import com.narbase.kunafa.core.css.*
import com.narbase.kunafa.core.dimensions.dependent.matchParent
import com.narbase.kunafa.core.dimensions.dependent.wrapContent
import com.narbase.kunafa.core.dimensions.percent
import com.narbase.kunafa.core.dimensions.px
import com.narbase.kunafa.core.dimensions.vw
import com.narbase.kunafa.core.drawable.Color
import com.narbase.kunafa.core.lifecycle.LifecycleOwner
import com.narbase.letsgo.dto.core.GenderDto
import com.narbase.letsgo.dto.dto
import com.narbase.letsgo.dto.enum
import com.narbase.letsgo.web.common.AppColors
import com.narbase.letsgo.web.dto.config.CallCenterConfigDto
import com.narbase.letsgo.web.dto.config.RoutingSettingsDto
import com.narbase.letsgo.web.dto.config.SipExtensionDto
import com.narbase.letsgo.web.dto.config.VoipSettingsDto
import com.narbase.letsgo.web.models.RoutingProvider
import com.narbase.letsgo.web.models.RoutingType
import com.narbase.letsgo.web.network.makeNotVisible
import com.narbase.letsgo.web.network.makeVisible
import com.narbase.letsgo.web.theme.theme
import com.narbase.letsgo.web.translations.localized
import com.narbase.letsgo.web.utils.horizontalFiller
import com.narbase.letsgo.web.utils.scrollable.scrollable
import com.narbase.letsgo.web.utils.verticalFiller
import com.narbase.letsgo.web.utils.views.*

class OperationSettingsManagementComponent : Component() {

    private val viewModel = OperationSettingManagementViewModel()
    private val popup by lazy { popUpDialog() }

    override fun onViewMounted(lifecycleOwner: LifecycleOwner) {
        super.onViewMounted(lifecycleOwner)
        viewModel.getConfig()
    }

    override fun View?.getView() = view {
        id = "driverProfileGroupsManagementRootView"

        style {
            matchParentDimensions
        }
        scrollable {
            style {
                matchParentDimensions
            }

            verticalLayout {
                style {
                    width = matchParent
                    height = wrapContent
                    padding = 32.px
                }


                horizontalLayout {
                    style {
                        width = matchParent
                    }
                    textView {
                        text = "Operation Settings".localized()
                        style {
                            width = wrapContent
                            fontSize = 20.px
                            fontWeight = "bold"
                        }
                    }

                    horizontalFiller()


                }
                verticalFiller(20)

                horizontalLayout {
                    style {
                        width = 50.percent
                    }
                    horizontalFiller(20)
                    verticalLayout {
                        withLoadingAndError(viewModel.getConfigUiState, onRetryClicked = {
                            viewModel.getConfig()
                        }, onLoaded = {
                            clearAllChildren()
                            val phoneNumberInput =
                                theme.labeledTextInput(this, "Call Center Phone Number:".localized(), false)
                            phoneNumberInput.text = viewModel.callCenterConfigDto?.phoneNumber ?: ""
                            phoneNumberInput.element.disabled = true


                            val locationRecencyInMinInput =
                                theme.labeledTextInput(this, "Passenger location recency in minutes:".localized(), false)
                            locationRecencyInMinInput.text = viewModel.callCenterConfigDto?.locationRecencyInMins.toString() ?: ""
                            locationRecencyInMinInput.element.disabled = true

                            verticalFiller(16)
                            sipSetting(viewModel.callCenterConfigDto?.sipExtension, viewModel.callCenterConfigDto?.voipSettings, true)
                            verticalFiller(16)
                            routingSettings(dto = viewModel.callCenterConfigDto?.routing, true)

                        })
                    }
                    horizontalFiller()

                    editCallCenterConfigButton()
                }
            }
        }
    }


    private fun LinearLayout.editCallCenterConfigButton() {
        theme.mainButton(this) {
            id = "editPhoneNumber"
            onClick = {
                upsertDialog(viewModel.callCenterConfigDto)
            }
            text = "Edit"
        }
    }

    private var upsertPhoneNumberField: TextInput? = null
    private var upsertLocationRecencyInMinsField: TextInput? = null
    private var upsertExtensionField: TextInput? = null
    private var upsertSpecialOfferExtensionField: TextInput? = null
    private var upsertSipDomainMinsField: TextInput? = null
    private var upsertTempFailTimeoutInMin: TextInput? = null
//    private var routingProviderDropList: RemoteDropDownList<RoutingProvider>? = null
//    private var routingTypeDropList: RemoteDropDownList<RoutingType>? = null
    var selectedRoutingProvider: RoutingProvider? = null
    var selectedRoutingType: RoutingType? = null

    private fun upsertDialog(dto: CallCenterConfigDto? = null) {
        viewModel.setUpsertUiStateToNull()
        theme.showDialog(popup) {

            verticalLayout {
                style {
                    height = wrapContent
                    width = 70.vw
                    backgroundColor = Color.white
                    padding = 20.px
                    borderRadius = 8.px
                }
                textView {
                    style {
                        fontWeight = "bold"
                        marginBottom = 8.px
                        fontSize = 16.px
                    }
                    text = "Edit Call Center Config".localized()
                }

                val phoneNumberInput = theme.labeledTextInput(this, "Phone Number".localized(), true)
                phoneNumberInput.element.type = "number"
                phoneNumberInput.element.placeholder = ""
                phoneNumberInput.text = dto?.phoneNumber?.replace("+", "")?: ""

                console.log( " phoneNumberInput.text = dto?.phoneNumber " + dto?.phoneNumber)

                upsertPhoneNumberField = phoneNumberInput

                val recentPassengerLocationInput = theme.labeledTextInput(this, "Passenger Location Recency in Minutes:".localized(), true)
                recentPassengerLocationInput.element.type = "number"
                recentPassengerLocationInput.element.placeholder = ""
                recentPassengerLocationInput.text = dto?.locationRecencyInMins?.toString() ?: ""

                upsertLocationRecencyInMinsField = recentPassengerLocationInput

                verticalFiller(16)

                sipSetting(dto?.sipExtension, dto?.voipSettings, false )
                verticalFiller(16)
                routingSettings(dto = dto?.routing, false)

                verticalFiller(12)
                val errorText = textView {
                    style {
                        marginBottom = 8.px
                        fontSize = 14.px
                        color = AppColors.redLight
                    }
                    isVisible = false
                    text = "Please enter valid fields values".localized()
                }
                verticalFiller(10)

                it.bottomBar = {
                    horizontalLayout {
                        style {
                            width = matchParent
                            height = wrapContent
                            justifyContent = JustifyContent.End
                            marginTop = 10.px
                        }

                        theme.mainButton(this) {

                            text = "Save".localized()
                            onClick = {
                                onSaveButtonClicked(
                                    errorText
                                )
                            }

                            withLoadingAndError(viewModel.upsertUiState, onRetryClicked = {
                                onSaveButtonClicked(
                                    errorText
                                )
                            }, onLoaded = {
                                popup.dismissDialog()
                                viewModel.getConfig()
                            })
                        }

                    }

                }

            }
        }
        upsertPhoneNumberField?.element?.focus()
    }

    private fun LinearLayout.sipSetting(dto : SipExtensionDto?, voipSettingsDto: VoipSettingsDto?, isDisabled: Boolean )  = verticalLayout {
        matchParentWidth()
        theme.subTitleFit(this, "SIP Settings".localized())
        upsertExtensionField = theme.labeledTextInput(this, "Call Center Extension".localized(), false) {
            text = dto?.extension ?: ""
            placeholder = "eg. ${defaultSipExtension.extension}"
            element.disabled = isDisabled
        }
        upsertSpecialOfferExtensionField = theme.labeledTextInput(this, "Special Off Extension: extension for passengers calling for the first time.".localized(), false) {
            text = dto?.specialOfferExtension ?: ""
            placeholder = if (isDisabled) "" else "eg. ${defaultSipExtension.extension}"
            element.disabled = isDisabled
        }
        upsertSipDomainMinsField = theme.labeledTextInput(this, "Server IP Address/domain (without port)".localized(), false) {
            text = dto?.domain ?: ""
            placeholder = "eg. ${defaultSipExtension.domain}"
            element.disabled = isDisabled
        }
        upsertTempFailTimeoutInMin = theme.labeledTextInput(this, "Timeout duration for Voip Crendentials on temporarily failure . (in minutes)".localized(), false) {
            text = voipSettingsDto?.tempFailTimeoutInMin?.toString() ?: 0.toString()
            type = "number"
            element.disabled = isDisabled
        }

    }

    private fun LinearLayout.routingSettings(dto : RoutingSettingsDto?, isDisabled: Boolean )  = verticalLayout {
        matchParentWidth()
        theme.subTitleFit(this, "Routing Settings".localized())

        if (isDisabled ) {
            theme.label(this, "Provider".localized(), !isDisabled)
            theme.text(this) {
                text = dto?.provider?.enum()?.dtoName ?: " - "
            }
            theme.label(this, "Type".localized(), !isDisabled)

            theme.text(this) {
                text = dto?.type?.enum()?.dtoName ?: " - "
            }
        } else {
            theme.label(this, "Provider".localized(), !isDisabled)
            setupDropDownList(
                "Provider".localized(),
                getList = { pageNo, _, _ -> if (pageNo == 0) RoutingProvider.values() else arrayOf() },
                itemToString = { it.name },
                onItemSelected = {
                    selectedRoutingProvider = it
                },
                viewWidthFactory = { matchParent },
                defaultItem = dto?.provider?.enum(),
            )
            theme.label(this, "Type".localized(), !isDisabled)
            setupDropDownList(
                "Type".localized(),
                getList = { pageNo, _, _ -> if (pageNo == 0) RoutingType.values() else arrayOf() },
                itemToString = { it.name },
                onItemSelected = {
                    selectedRoutingType = it
                },
                viewWidthFactory = { matchParent },
                defaultItem = dto?.type?.enum()

            )

        }


    }

    private fun onSaveButtonClicked(
        errorText: TextView
    ) {
        val phoneNumberInput = upsertPhoneNumberField ?: return
        val locationRecencyInMinsInput = upsertLocationRecencyInMinsField ?: return
        val extensionInput = upsertExtensionField ?: return
        val specialOfferExtensionInput = upsertSpecialOfferExtensionField ?: return
        val sipDomainInput = upsertSipDomainMinsField ?: return
        val tempFailTimeoutInMinInput = upsertTempFailTimeoutInMin ?: return

        val phoneNumber = phoneNumberInput.text.trim()
        val locationRecencyInMins : Int? = locationRecencyInMinsInput.text.trim().toIntOrNull()
        val extension : String = extensionInput.text.trim()
        var specialOfferExtension : String? = specialOfferExtensionInput.text.trim()
        val sipDomain : String = sipDomainInput.text.trim()
        val tempFailTimeoutInMin : Int? = tempFailTimeoutInMinInput.text.trim().toIntOrNull()

        val provider = selectedRoutingProvider
        val routingType = selectedRoutingType

        if (phoneNumber.isBlank()) {
            makeVisible(errorText)
            errorText.text = "Please enter a valid phone number".localized()
            return
        }
        if (locationRecencyInMins == null) {
            makeVisible(errorText)
            errorText.text = "Please enter a valid duration in minutes for recent passenger location max duration ".localized()
            return
        }

        if (extension.isBlank()) {
            makeVisible(errorText)
            errorText.text = "Please enter a valid call center SIP extension".localized()
            return
        }
        if (specialOfferExtension?.isBlank() == true) {
            specialOfferExtension = null

        }
        if (sipDomain.isBlank()) {
            makeVisible(errorText)
            errorText.text = "Please enter a valid IP address for the SIP server".localized()
            return
        }
        if (provider == null) {
            makeVisible(errorText)
            errorText.text = "Please select a routing provider".localized()
            return
        }
        if (routingType == null) {
            makeVisible(errorText)
            errorText.text = "Please select a routing type".localized()
            return
        }

        makeNotVisible(errorText)

        val sipExtensionDto = SipExtensionDto(
            extension = extension,
            domain = sipDomain,
            specialOfferExtension = specialOfferExtension
        )
        val routingSettingsDto = RoutingSettingsDto(
            provider = provider.dto(),
            type = routingType.dto()
        )
        val voipSettingsDto = VoipSettingsDto(
            tempFailTimeoutInMin = tempFailTimeoutInMin ?: 0
        )

        viewModel.editItem(
            CallCenterConfigDto(
                phoneNumber = phoneNumber,
                locationRecencyInMins = locationRecencyInMins,
                sipExtension = sipExtensionDto ?: defaultSipExtension,
                routing = routingSettingsDto,
                voipSettings = voipSettingsDto
            )
        )
    }

    val defaultSipExtension = SipExtensionDto(extension = "600", domain = "82.29.178.68", specialOfferExtension = null)

}